import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid/main';
import { SearchEvent } from '../../../../models/search-event';
import { ITEM_CLICK_EVENT } from '../../../../search-constants';
import { DatePickerConfigService } from '../../../../../components/datepicker/datepicker-config.service';
import { META_DATA } from '../../../../../../constants';

@Component({
  selector: 'lfwms-basic-cell-renderer',
  templateUrl: './basic-cell-renderer.component.html',
  styleUrls: ['./basic-cell-renderer.component.css']
})
export class BasicCellRendererComponent implements ICellRendererAngularComp {

  public isLoading: boolean = true;
  public params: any;
  public templateId: number = 0;
  public cellValue: any;
  public cellDisplayValue: any;

  // Flag to display the 'x' mark / checkbox
  public isNewRow: boolean = false;

  constructor(private dateConfigService: DatePickerConfigService) {

  }

  public agInit(params: ICellRendererParams): void {
    this.params = params;
    this.cellValue = this.params.value;
    /* For new rows, row selection checkbox will be
      replaced with row delete button 'x' button */
    if (this.params.node.data['isNewItem']) {
      this.isNewRow = this.params.node.data['isNewItem'].cVal;
    }
    if (this.params.column.colDef.colId === 'isSelected') {
      // Row selection checkbox template
      this.templateId = 1;
      this.cellValue = this.params.value;
    } else if (this.params.value) {
      this.cellValue = this.params.value.cVal;
      if (this.params.context.componentParent
        .tableConfig.showIdAsAHyperLink && (this.params.column.colDef.colId
          === this.params.context.componentParent
            .searchService.searchParams.idProperty)) {
        // Hyperlink template
        this.templateId = 2;
      } else if (this.params.context.componentParent.tableConfig.showIdAsAHyperLink && this.params.column.colDef.colId === META_DATA.MBOL_KEY) {
          this.templateId = 7;
      } else if (this.params.context.componentParent.tableConfig.showIdAsAHyperLink && this.params.column.colDef.colId === META_DATA.SO_USER_DEFINED_NINE) {
          this.templateId = 8;
      } else if (this.params.cellMetaData
        && this.params.cellMetaData.dataType === 'Currency') {
        // Currency template
        this.templateId = 3;
      } else if (this.params.cellMetaData
        && this.params.cellMetaData.type === 'DROPDOWN' || this.params.cellMetaData.type === 'EDITABLEDROPDOWN') {
          let filteredOptions: Array<any>;            
          //LFWM-3357 value is shown for some restricted dropdown lists.
          if(this.params.value.cOptions !== undefined){
            filteredOptions = this.params.value.cOptions.filter((option: any) =>{
              if(option.key && this.cellValue && typeof (option.key) === 'string' && typeof (this.cellValue) === 'string')
                return option.key.toUpperCase() === this.cellValue.toUpperCase();
              else 
                return option.key === this.cellValue;
              
            });
          } else {
               filteredOptions = this.params.cellMetaData.values.filter((option: any) => {
                // For string type dropdowns case insensitive comparison is done
                if(option.key && this.cellValue && typeof (option.key) === 'string' && typeof (this.cellValue) === 'string') {
                  return option.key.toUpperCase() === this.cellValue.toUpperCase();
                } else {
                  return option.key === this.cellValue;
                }
              });
          }

        // LFWM-2709 - display only key in view mode
        //LFWM-3357- display value of dropdown in view mode
        this.cellDisplayValue = ((filteredOptions.length > 0) ? filteredOptions[0].value : this.cellValue);
        if (this.cellDisplayValue === '- Select -') {
          this.cellDisplayValue = '';
        }
        // Dropdown template
        this.templateId = 4;
      } else if (this.params.cellMetaData
        && (this.params.cellMetaData.type === 'CHECKBOX' || this.params.cellMetaData.type === 'CHECKBOX_CHR')) {
        // Adding CHECKBOX_CHR type denoting the saved value will be 'Y' or 'N'
        // CHECKBOX type denoting the saved value will be '1' or '0'
        // Checkbox template
        this.templateId = 5;
        this.cellValue = this.params.value.cVal;
      } else if (this.params.cellMetaData &&
        (this.params.cellMetaData.type === 'DATE' || this.params.cellMetaData.type === 'DATETIME')) {
        // Date or Datetime Template
        this.templateId = 6;
        if (this.params.cellMetaData.type === 'DATE' && this.params.value.cVal) {
          this.cellValue = this.dateConfigService.getFormattedDisplayDate(this.params.value.cVal);
        } else if (this.params.cellMetaData.type === 'DATETIME' && this.params.value.cVal) {
          this.cellValue = this.dateConfigService.getFormattedDisplayDateTime(this.params.value.cVal);
        }
      } else {
        // Default renderer template
        this.templateId = 0;
      }
    }
    this.isLoading = false;
  }

  public refresh(params: any): boolean {
    this.params = params;
    if (this.params.column.colDef.colId === 'isSelected') {
      this.cellValue = this.params.value;
    } else {
      if (this.params.value) {
        /* JIRA LFWM-1756 Fixes - Date format [country specific format ] of already existing date changes
       to default input format [YYYY-MM-DD HH:mm:ss] when choosing dates from calender. It should be displyed
       in the country specific format always */
        if (this.params.colDef.cellEditorParams.cellMetaData.type === 'DATE' && this.params.value.cVal) {
          this.cellValue = this.dateConfigService.getFormattedDisplayDate(this.params.value.cVal);
        } else if (this.params.colDef.cellEditorParams.cellMetaData.type === 'DATETIME' && this.params.value.cVal) {
          this.cellValue = this.dateConfigService.getFormattedDisplayDateTime(this.params.value.cVal);
        } else {
          this.cellValue = this.params.value.cVal;
        }
      }
    }
    return true;
  }

  public navigateToHyperlink() {
    this.params.context.componentParent.tableEditor.navigateToHyperlink(this.params);
  }
  public navigateToHyperlinkMbol() {
    this.params.context.componentParent.tableEditor.navigateToHyperlinkMbol(this.params);
  }

  public navigateToHyperlinkUsDf09() {
    this.params.context.componentParent.tableEditor.navigateToHyperlinkUsDf09(this.params);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/search/results/result-data-table/renderers/basic-cell-renderer/basic-cell-renderer.component.ts